module.exports = __webpack_public_path__ + "img/02-green.c3ce3281.svg";